/** Right-pointing chevron (Heroicons mini), used as a breadcrumb separator and list affordance. */
export function ChevronRightIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 20 20"
      fill="currentColor"
      aria-hidden="true"
    >
      <path
        fillRule="evenodd"
        d="M7.21 14.77a.75.75 0 0 1 0-1.06L10.94 10 7.21 6.29a.75.75 0 1 1 1.08-1.04l4.24 4.25a.75.75 0 0 1 0 1.06l-4.24 4.25a.75.75 0 0 1-1.08-.04z"
        clipRule="evenodd"
      />
    </svg>
  );
}
